// @core/api/endpoints/task/list_activity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListActivityResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List task activity
 * Returns the complete activity log for a task showing all changes, comments, and events in chronological order.
 */
export async function ListActivity(
  task_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListActivityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/activity`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<ListActivityResponse>(requestPath, { ...requestOptions, params });
}
